import { Component, OnInit, ElementRef, ViewEncapsulation} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { DragulaService } from 'ng2-dragula';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../dynamic-detail/dynamic-detail.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ListComponent implements OnInit {
  myForm: FormGroup;
  badgeClass = 'info'
  badgeClass2 = 'success'
  badgeClass3 = 'warning'
  badgeClass4 = 'danger'
  taskData_normal: any
  taskData_medium: any
  taskData_high: any
  taskData_urgent: any

  taskDetail: any
  taskId: any
  user_role: any
  task_id: any
  normal_priority = '643e823159b78b65557d74ab'
  medium_priority = '643e84ec59b78b65557d7526'
  high_priority = '643e851c59b78b65557d752d'
  urgent_priority = '643e854959b78b65557d7534'
  isEmpList: boolean = false
  isTeamList: boolean = false
  isStudentList: boolean = false
  isBatchList: boolean = false
  isScheduleList: boolean = false
  isPriorityList: boolean = false
  isType: boolean = false
  isTaskLabel: boolean = false
  isTime: boolean = false
  isBudget: boolean = false
  isDueDate: boolean = false
  isMandatory: boolean = false
  isEmployee: boolean = false
  isStudent: boolean = false
  isProjectList: boolean = false
  isCheckList: boolean = false
  isLeadType: boolean = false
  isTrainingLead: boolean = false
  isOutsourceLead: boolean = false
  isTeam_selected_list: boolean = false
  isBatch_selected_list: boolean = false

  team_selected_list = []
  team_selected_list_data: string[] = [];
  batch_selected_list = []
  batch_selected_list_data: string[] = [];
  empList = []
  teamList = []
  studentList = []
  batchList = []
  selectTeam: string[] = [];
  selectedEmp: string[] = [];
  selectedStudent: string[] = [];
  selectedBatch: string[] = [];
  selectedSchedule = null
  selectedMandatory = null
  selectedTaskLabel = null
  selectedType = null
  teamId = "631ad9d8ce5c666542591bee"

  isAllSelected = false;

  scheduleList = [
    { name: 'One Time', id: 'oneTime' },
    { name: 'Twice in a day', id: 'twice_in_a_day' },
    { name: 'Once in a day', id: 'once_in_a_day' },
    { name: 'Weekly', id: 'weekly' },
    { name: 'Bi-Weekly', id: 'bi_weekly' },
    { name: 'Monthly', id: 'monthly' },
    { name: 'Half-Yearly', id: 'half_yearly' },
    { name: 'Yearly', id: 'yearly' }

  ]
  mandatoryList = [
    { name: 'No', id: 'no' },
    { name: 'Yes', id: 'yes' },
  ]
  typeList = [
    { name: 'Ticket', id: 'ticket' },
    { name: 'Projects', id: 'projects' },
    { name: 'Leads', id: 'leads' },
    { name: 'Checklist', id: 'checklist' },
    { name: 'Message', id: 'message' }
  ]
  taskLabelList = []

  leads_type = [
    { name: 'Training', id: 'training' },
    { name: 'Outsource', id: 'outsource' },
  ]
  select_leadType = null

  task_label_catId = '643e7f6f59b78b65557d744a'
  task_priority_catId = '643e7faf59b78b65557d744e'
  task_priority_List = []
  selected_task_priority = '643e823159b78b65557d74ab'

  current_date: any
  time: any
  budget_val: any
  selectedItemCount: number = 0;

  project_list = []
  select_project: string[] = [];
  check_list = []
  select_checklist: string[] = [];
  training_list = []
  outsource_list = []
  select_training_lead : string[] = [];
  select_outsource_lead : string[] = [];
  task_for_selected: any
  isDropdownOpen: boolean = false
  isDropdownOpen_student: boolean = false
  isDropdownOpen_employee: boolean = false

  isDemotask_modal :boolean =false

  page = {
    pageNumber: 0,
    offset: 0,
    pageSize: 10,
    totalPages: 0
  };
  public rows = [];
  public filterRows = [];
  public ColumnMode = ColumnMode;
  public limitRef = 10;
  public columns = [
    { name: " Name", prop: "name" },
    { name: "Email", prop: "email" },
    { name: "Actions", prop: "actions" },
  ];

  guideline_data:any

  constructor(private elRef: ElementRef,
    private dragulaService: DragulaService,
    private route: Router, private modalService: NgbModal,
    private apiService: ApiService, public toastr: ToastrService,
    private formBuilder: FormBuilder,private spinner: NgxSpinnerService,
  ) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
    let setting_data = JSON.parse(localStorage.getItem('setting-record'))
    let key_data = setting_data.filter((item) => item.key == 'Task')
    this.guideline_data = key_data[0]?._id
    this.selectedType = 'ticket'
    this.selectedSchedule = 'oneTime'
    this.selectedMandatory = 'no'
    this.current_date = this.getCurrentDate()
    this.time = 1
    this.budget_val = 0
  }

  ngOnInit() {
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen_student = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isDropdownOpen_employee = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isScheduleList = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isPriorityList = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isTaskLabel = false;
      }
    });
    document.addEventListener('click', (event) => {
      if (!(event.target as HTMLElement).closest('.dropdown')) {
        this.isMandatory = false;
      }
    });
    this.isEmployee = true;
    this.isEmpList = true;
    this.task_for_selected = 'employee'
    this.myForm = this.formBuilder.group({
      title: ['', Validators.required],
      message: ['', Validators.required],
      type: ['', Validators.required],
      due_date: [this.current_date,],
      body: ['',],
      time: [this.time,],
      budget: [this.budget_val,],
    });
    this.dragulaService.drop('ITEMS').subscribe(({ el, target }) => {
      
      const elements = el.querySelectorAll('[task-index]');
      const targett = target.querySelectorAll('[task-index]');
      var fromIndex
      var fromPriorityId
      var toIndex
      var toPriorityId

        fromIndex = el.getAttribute('task-index');
        fromPriorityId = el.getAttribute('task-priority');
        const priority_name = el.getAttribute('task-priorityname');        
      targett.forEach((element:any)=>{
        toIndex = element.getAttribute('task-index');
        toPriorityId = target.id;
      })
        this.updateTaskStatus(fromIndex,fromPriorityId,toIndex,toPriorityId);
   
    });

    this.getTaskNormal()
    this.getTaskMedium()
    this.getTaskHigh()
    this.getTaskUrgent()
    this.getAllEmployee()
    this.getEmployeeCategory()
    this.getAllStudents()
    this.getAllBatch()
    this.getTaskPriorityList()
    this.getTaskLabelList()
  }

  getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = this.padNumber(today.getMonth() + 1);
    const day = this.padNumber(today.getDate());
    return `${year}-${month}-${day}`;
  }

  padNumber(number: number): string {
    return number < 10 ? `0${number}` : `${number}`;
  }

  getChangeTypeId(event) {
    this.selectedType
    if (event.name == 'Projects') {
      this.isProjectList = true
      this.isCheckList = false
      this.isLeadType = false
      this.getProjectList()
    }
    if (event.name == 'Checklist') {
      this.isCheckList = true
      this.isLeadType = false
      this.isProjectList = false
      this.getCheckList()
    }
    if (event.name == 'Leads') {
      this.isLeadType = true
      this.isProjectList = false
      this.isCheckList = false
    }
  }
  getProjectList() {
    this.apiService.getJobsByStatus('6428038677a2ab2fb559dc36', 1, 100, '', 'current').subscribe((res: any) => {
      this.project_list = res.data.items
    })
  }
  getProjectId(event) {
    this.select_project
  }
  getCheckList() {
    this.apiService.getAllChecklist(1, 100,'').subscribe((res: any) => {
      this.check_list = res.data.items
    })
  }
  getCheckListId(event) {
    this.select_checklist
  }
  getLeadTypeId(event) {
    this.select_leadType
    if (event.name === 'Training') {
      this.isTrainingLead = true
      this.getTrainingLead()
    }
    if (event.name === 'Outsource') {
      this.isOutsourceLead = true
      this.getOutsourceLead()
    }
  }
  getTrainingLead() {
    this.apiService.getLeadsByTagId(1, 100, '63e39db72052e0098e18e00e', '63e396fe2052e0098e18def3', 'active').subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.training_list = res.items
      }
    })
  }
  getTrainingLeadId(event) {
    this.select_training_lead
  }
  getOutsourceLead() {
    this.apiService.getOutsourceLeadsByTagId(1, 100, '63e396de2052e0098e18deec', '63e39dd62052e0098e18e015','').subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.outsource_list = res.items
      }
    })
  }
  getOutsourceLeadId(event) {
    this.select_outsource_lead
  }
  getAllEmployee() {
    this.apiService.getEmployeeList(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.empList = res.items
      }
    })
  }
  getAllStudents() {
    this.apiService.getAllStudents(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.studentList = res.items
      }
    })
  }
  getAllBatch() {
    this.apiService.getBatchList(1, 100).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.batchList = res.data.items
      }
    })
  }
  getEmployeeCategory() {
    this.apiService.getTagByTagCatgoryId(this.teamId).subscribe((res: any) => {
      this.teamList = res.data
    })
  }
  getTaskPriorityList() {
    this.apiService.getTagByTagCatgoryId(this.task_priority_catId).subscribe((res: any) => {
      this.task_priority_List = res.data
    })
  }
  getChangeTaskPriority(id) {
    this.selected_task_priority = id
  }
  editTask(id) {
    this.route.navigate(['task/edit', id])
  }
  getTaskNormal() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const userRoleId = this.user_role?.roles === 'admin' ? null : this.user_role?.id || '';

    this.apiService.getTaskByPriority(this.normal_priority, 1, 300,userRoleId).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_normal = res.data.items.reverse()
      this.taskData_normal.concat(this.taskData_high)
    })
  }
  getTaskMedium() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const userRoleId = this.user_role?.roles === 'admin' ? null : this.user_role?.id || '';

    this.apiService.getTaskByPriority(this.medium_priority, 1, 300,userRoleId).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_medium = res.data.items.reverse()
      this.taskData_medium.concat(this.taskData_urgent)
    })
  }
  getTaskHigh() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const userRoleId = this.user_role?.roles === 'admin' ? null : this.user_role?.id || '';

    this.apiService.getTaskByPriority(this.high_priority, 1, 300,userRoleId).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_high = res.data.items.reverse()
    })
  }
  getTaskUrgent() {
    this.spinner.show(undefined, {
      type: "ball-triangle-path",
      size: "medium",
      bdColor: "rgba(0, 0, 0, 0.8)",
      color: "#fff",
      fullScreen: true,
    });
    const userRoleId = this.user_role?.roles === 'admin' ? null : this.user_role?.id || '';

    this.apiService.getTaskByPriority(this.urgent_priority, 1, 300,userRoleId).subscribe((res: any) => {
      this.spinner.hide()
      this.taskData_urgent = res.data.items.reverse()
    })
  }
  getTaskId(id: any) {
    this.taskId = id
    this.getTaskById()
  }
  getTaskById() {
    this.apiService.getTaskById(this.taskId).subscribe((res: any) => {
      this.taskDetail = res.data
    })
  }
  confirmDelete(id) {
    this.task_id = id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be delete this task!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.deleteTask(this.task_id)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe :)',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }

  deleteTask(id) {
    this.apiService.taskDelete(id).subscribe((res: any) => {
      if (res.statusCode === 200) {
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        this.getTaskNormal()
        this.getTaskMedium()
        this.getTaskHigh()
        this.getTaskUrgent()
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })

  }
  openModal(content,) {

    const modalRef = this.modalService.open(content);

    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }



  // --------------- Student ------------------------------------------------------------------
  toggleAllSelectionStudent() {
    this.selectedStudent = [];
    this.isAllSelected = !this.isAllSelected;
    this.studentList.forEach((item, index) => {
      item.selected = this.isAllSelected;
      if (this.isAllSelected) {
        this.selectedStudent.push(item.id);
      }
      // Update the selected item count
      if (index < 5) {
        this.selectedItemCount = this.isAllSelected ? 5 : 0;
      } else if (index === 5) {
        this.selectedItemCount = this.isAllSelected ? 5 : 0;
      }
    });
  }
  toggleSelectionStudent(item) {
    if (item.selected) {
      this.selectedEmp.push(item.id);
    } else {
      const index = this.selectedStudent.findIndex((selectedItem) => selectedItem === item);
      if (index !== -1) {
        this.selectedStudent.splice(index, 1);
      }
    }
    this.isAllSelected = this.studentList.every((emp) => emp.selected);
  }
  onDropdownOpenStudent() {
    this.isAllSelected = this.studentList.every((item) => item.selected);
  }

  onDropdownCloseStudent() {
    this.isAllSelected = this.studentList.every((item) => item.selected);
  }
  // --------------- Team ------------------------------------------------------------------

  toggleAllSelectionTeam() {
    this.selectTeam = [];
    this.isAllSelected = !this.isAllSelected;
    this.teamList.forEach((item) => {
      item.selected = this.isAllSelected;
      if (this.isAllSelected) {
        this.selectTeam.push(item);
      }
    });
  }

  toggleSelectionTeam(item) {
    if (item.selected) {
      this.selectTeam.push(item);
      if (item != '') {
        this.apiService.getEmployeeByTeamId(item._id, 1, 100).subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.isTeam_selected_list = true
            let data = res.items
            for (let item of data) {
              this.team_selected_list.push(item.user[0])
            }
            this.team_selected_list_data = this.team_selected_list.map(item => item._id)
          }
        })
      }

    } else {
      const index = this.selectTeam.findIndex((selectedItem) => selectedItem === item);
      if (index !== -1) {
        this.selectTeam.splice(index, 1);
      }
    }
    this.isAllSelected = this.teamList.every((team) => team.selected);
  }

  onDropdownOpenTeam() {
    this.isAllSelected = this.teamList.every((item) => item.selected);
  }

  onDropdownCloseTeam() {
    this.isAllSelected = this.teamList.every((item) => item.selected);
  }
  // --------------- Employee ------------------------------------------------------------------
  toggleAllSelectionEmp() {
    this.selectedEmp = [];
    this.isAllSelected = !this.isAllSelected;
    this.empList.forEach((item) => {
      item.selected = this.isAllSelected;
      if (this.isAllSelected) {
        this.selectedEmp.push(item._id);
      }
    });
  }

  toggleSelectionEmp(item) {
    if (item.selected) {
      this.selectedEmp.push(item._id);
    } else {
      const index = this.selectedEmp.findIndex((selectedItem) => selectedItem === item);
      if (index !== -1) {
        this.selectedEmp.splice(index, 1);
      }
    }
    this.isAllSelected = this.empList.every((emp) => emp.selected);
  }

  onDropdownOpenEmp() {
    this.isAllSelected = this.empList.every((item) => item.selected);
  }

  onDropdownCloseEmp() {
    this.isAllSelected = this.empList.every((item) => item.selected);
  }
  // --------------- Batch ------------------------------------------------------------------
  toggleAllSelectionBatch() {
    this.selectedBatch = [];
    this.isAllSelected = !this.isAllSelected;
    this.batchList.forEach((item) => {
      item.selected = this.isAllSelected;
      if (this.isAllSelected) {
        this.selectedBatch.push(item);
      }
    });
  }

  toggleSelectionBatch(item) {
    if (item.selected) {
      this.selectedBatch.push(item);
      if (item._id != '') {
        this.apiService.getEnrolmentsByBatchId(item._id,'').subscribe((res: any) => {
          if (res.statusCode === 200) {
            this.isBatch_selected_list = true
            this.batch_selected_list = res.data
            // for(let item of data){
            //   this.batch_selected_list.push(item.user[0])
            // }
            this.batch_selected_list_data = this.batch_selected_list.map(item => item._id)
          }
        })
      }

    } else {
      const index = this.selectedBatch.findIndex((selectedItem) => selectedItem === item);
      if (index !== -1) {
        this.selectedBatch.splice(index, 1);
      }
    }
    this.isAllSelected = this.batchList.every((batch) => batch.selected);
  }

  onDropdownOpenBatch() {
    this.isAllSelected = this.batchList.every((item) => item.selected);
  }

  onDropdownCloseBatch() {
    this.isAllSelected = this.batchList.every((item) => item.selected);
  }
  onMenuItemClick(item: string) {
    console.log('Clicked:', item);
    // Add your custom logic here
  }
  getTaskLabelList() {
    this.apiService.getTagByTagCatgoryId(this.task_label_catId).subscribe((res: any) => {
      this.taskLabelList = res.data

      let obj={
        _id: "demo",
        name: "demo",
        displayname: "Demo",
    }
    this.taskLabelList.push(obj)


    })
  }
  getChangeTaskLabelId(id) {
    this.selectedTaskLabel = id
  }

  getChangeScheduleId(id) {
    this.selectedSchedule = id
  }
  getChangeMandatoryId(id) {
    this.selectedMandatory = id

  }
  createTask() {

    let body = {
      title: this.myForm.value.title,
      body: this.myForm.value.body,
      scheduleduration: this.myForm.value.due_date,
      working_hours: this.myForm.value.time,
      budget: this.myForm.value.budget,
      // type : '63e39db72052e0098e18e00e',
      type_projects: this.select_project,
      type_checklist: this.select_checklist,
      type_training: this.select_training_lead,
      type_outsource: this.select_outsource_lead,
      to: this.selectedStudent,
      priority: this.selected_task_priority,
      label: this.selectedTaskLabel,
      is_schedule: this.selectedSchedule,
      is_mandatory: this.selectedMandatory,
      stage: '64ae445ee0a6ff2e7db78317',
      status:'643e869259b78b65557d755a'
    }
    if (this.selectedStudent.length > 0) {
      body.to = this.selectedStudent
    }
    if (this.selectedBatch.length > 0) {
      body.to = this.batch_selected_list_data
    }
    if (this.selectedEmp.length > 0) {
      body.to = this.selectedEmp
    }
    if (this.selectTeam.length > 0) {
      body.to = this.team_selected_list_data
    }
    // console.log('form val',body)
    this.apiService.createTask(body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.toastr.success('task created successfully!')
        this.route.navigate(['/task/list'])
        this.modalService.dismissAll()
        this.getTaskNormal()
        this.getTaskMedium()
        this.getTaskHigh()
        this.getTaskUrgent()

      }
      else {
        this.toastr.error(res.error)
      }
    })

  }
  toggleActive(selected_item) {
    if (selected_item === 'emp-ind') {
      this.isEmpList = true;
      this.isTeamList = false
      this.isStudentList = false;
      this.isBatchList = false
    }
    else if (selected_item === 'emp-team') {
      this.isTeamList = true
      this.isEmpList = false;
      this.isStudentList = false;
      this.isBatchList = false
    }
    else if (selected_item === 'student-ind') {
      this.isStudentList = true;
      this.isBatchList = false
      this.isTeamList = false
      this.isEmpList = false;

    }
    else if (selected_item === 'student-batch') {
      this.isBatchList = true
      this.isStudentList = false;
      this.isTeamList = false
      this.isEmpList = false;
    }
  }
  toggleActiveStudent(name) {
    if (name === 'emp') {
      this.task_for_selected = 'employee'
      this.isEmployee = true;
      this.isEmpList = true
      this.isStudent = false;
      this.isStudentList = false
    }
    if (name === 'student') {
      this.task_for_selected = 'student'
      this.isStudent = true;
      this.isStudentList = true
      this.isEmpList = false
      this.isEmployee = false;
      this.isTeamList = false;

    }
  }

  updateTaskStatus(fromIndex, fromPriority, toIndex, toPriority) {

    if( fromIndex !='' && fromPriority !='' && toIndex !='' && toPriority !=''){
      let body = {

        moveFrom: fromIndex,
        moveTo: toIndex,
        priorityFrom: fromPriority,
        priorityTo: toPriority
    }
    this.apiService.taskOrderChange(body).subscribe((res: any) => {
      if (res.statusCode === 200) {
        this.getTaskNormal()
        this.getTaskMedium()
        this.getTaskHigh()
        this.getTaskUrgent()
      }
    })
    }
  }
  openDemoModal(content){
    const modalRef = this.modalService.open(content);
    this.isDemotask_modal=true
    this.selectedTaskLabel='64749d694c173b1abc51e6c4'
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
  copyItem(id){
    let url = `https://do.meander.software/task-view/${id}`
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = url
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastr.info('copy task url')
  }
 
}
